export const capitalizeFirstCharacter = (word: string) => {
  const firstChar = word.charAt(0).toLocaleUpperCase();

  return firstChar.concat(word.slice(1));
};
